import Image from "next/legacy/image"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"
import styles from "./details.module.css"

export default function Person({ person }) {
  if (!person) {
    return null
  }

  const emailHash = Buffer.from(person.email, "binary").toString("base64")

  function showEmail(hash) {
    window.location.href =
      "mailto:" + Buffer.from(hash, "base64").toString("ascii")
  }

  return (
    <div className={styles.details}>
      <div className="inner-wrapper">
        {person.avatar.url && (
          <div className="figure-wrapper">
            <figure>
              <Image
                className="object-cover object-center w-full h-full"
                src={person.avatar.url}
                sizes="(max-width: 768px) 512px, 360px"
                alt={person.avatar.alt}
                layout="fill"
                loading="lazy"
              />
            </figure>
          </div>
        )}

        <div className="content-wrapper">
          <HeadingLabel className="position">{person.position}</HeadingLabel>
          <h3 className="full-name">{person.name}</h3>
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: person.desc }}></div>
          <button
            className="underline link"
            aria-label="Mejla mig"
            onClick={() => showEmail(emailHash)}>
            Mejla mig
          </button>
          {person.phone && (
            <div className="link">
              <span>Telefon: </span>
              <a key="phone" href={`tel:${person.phone}`}>
                {person.phone}
              </a>
            </div>
          )}

          {person.altPhone && (
            <div className="link">
              <span>Mobil: </span>
              <a key="phone" href={`tel:${person.altPhone}`}>
                {person.altPhone}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
